import React, { Fragment, useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'

import { debounce, isEmpty, uniqueId } from 'lodash'
import Measure from 'react-measure'

import { Box, Popper, Paper, Typography } from '@material-ui/core'

import renderMap from './render-map'

const debouncedResize = debounce(renderMap, 500)

const MapView = ({ stats, onSelectState }) => {
  const ref = useRef(null)
  const [target, setHoverTarget] = useState()
  const mapId = useRef(uniqueId('audience-map-popover'))
  useEffect(() => {
    renderMap(ref.current, stats, onSelectState, setHoverTarget)
  }, [stats, onSelectState])
  return (
    <Measure
      onResize={() => {
        if (stats && !isEmpty(stats)) debouncedResize(ref.current, stats, onSelectState, setHoverTarget)
      }}
    >
      {({ measureRef }) => (
        <div
          ref={measureRef}
          aria-hidden="true"
        >
          <svg
            width="100%"
            ref={ref}
          />
          <Popper
            open={!!target}
            anchorEl={target && target.select}
            placement="top"
            id={mapId.current}
          >
            {target && (
              <Box
                component={Paper}
                textAlign="center"
                p={1}
              >
                <Typography variant="body2">{target.name}</Typography>
                <Typography>
                  <strong>{target.count >= 0 ? String(target.count) : <Fragment>&mdash;</Fragment>}</strong>
                </Typography>
                <Typography variant="body2">Students</Typography>
              </Box>
            )}
          </Popper>
        </div>
      )}
    </Measure>
  )
}
MapView.propTypes = {
  stats: PropTypes.object,
  onSelectState: PropTypes.func.isRequired,
}

export default MapView
